import { configuration as configurationRoute } from '../../../data/enums/Route';

const breadCrumb = [configurationRoute];

export { breadCrumb };
